export const onMount = (callback) => {
  if (typeof callback === "function") {
    if (document.readyState === "complete") {
      callback();
    } else {
      window.addEventListener("load", callback);
    }
  }
};
